<template>
	<layer class="opt_more_g writer_opt" name="user">
		<div class="box_opt_menu member_type">
			<div class="menu_item">
				<a href="javascript:" class="link_menu" @click="goProfile">회원정보</a>
			</div>
			<div class="menu_item" v-if="canEditRolecode" @mouseenter="showCafeRoles" @mouseleave="hideCafeRoles">
				<a href="javascript:" class="link_menu">등급변경<span class="ico_bbs ico_view">등급메뉴</span></a>
				<div class="box_opt_menu box_opt_sub">
					<div class="menu_item" v-for="{code, name} in cafeRoles">
						<a href="javascript:" class="link_menu" @click="changeCafeRole(code)">{{ name }}</a>
					</div>
				</div>
			</div>
			<div class="menu_item">
				<a href="javascript:" class="link_menu" @click="goArticle">작성글 보기</a>
			</div>
			<template v-if="canSendToUser">
				<div class="menu_item">
					<a href="javascript:" class="link_menu" @click="sendWebMemo">쪽지 보내기</a>
				</div>
				<div class="menu_item">
					<a href="javascript:" class="link_menu" @click="sendEmail">메일 보내기</a>
				</div>
			</template>
		</div>
	</layer>
</template>

<script>
import Layer from './Layer.vue';

export default {
	components: {Layer},
	props: {
		grpid: String,
		isAdmin: Boolean,
		rolecode: String,
		encUserId: String,
		isMine: Boolean,
		author: String,
		cafeRoles: Array,
		canEditRolecode: Boolean
	},
	data() {
		return {
			REGULAR_MEMBER_CODE: '25'
		};
	},
	computed: {
		canSendToUser() {
			return parseInt(this.rolecode) > parseInt(this.REGULAR_MEMBER_CODE);
		}
	},
	methods: {
		goProfile() {
			window.goProfile(this.grpid, this.encUserId, this.rolecode, this.isMine.toString());
		},
		changeCafeRole(code) {
			window.MemberRole.changeAtRead(code, this.encUserId);
		},
		goArticle() {
			window.goArticle(this.encUserId, this.grpid, this.author, this.isAdmin, this.isMine.toString());
		},
		sendWebMemo() {
			window.sendWebMemo(this.grpid, this.encUserId, this.isMine.toString());
		},
		sendEmail() {
			window.sendEmail(this.grpid, this.encUserId);
		},
		showCafeRoles({currentTarget}) {
			currentTarget.classList.add('open_sub');
		},
		hideCafeRoles({currentTarget}) {
			currentTarget.classList.remove('open_sub');
		}
	}
}
</script>
